import type { ModalProps } from 'core/components/ui';
import { Modal } from 'core/components/ui';
import { Outlet } from 'react-router-dom';

export function ModalLayout(props: ModalProps) {
  return (
    <Modal data-test-id="modal-layout" open {...props}>
      <Outlet />
    </Modal>
  );
}
